import { render } from "./PostDetail.vue?vue&type=template&id=b3e8ddf0&scoped=true"
import script from "./PostDetail.vue?vue&type=script&lang=js"
export * from "./PostDetail.vue?vue&type=script&lang=js"

import "./PostDetail.vue?vue&type=style&index=0&id=b3e8ddf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e8ddf0"]])

export default __exports__